const fullNameFilter = (value) => {
  if (!value) return '';

  return `${ value.firstName || '' }${ value.firstName && value.lastName ? ' ' : '' }${ value.lastName || '' }`;
}

export default fullNameFilter;
